export type ArtifactLike = {
  artifact_id?: string
  artifactId?: string
  download_url?: string | null
  downloadUrl?: string | null
  filename?: string | null
  artifact_type?: string | null
  artifactType?: string | null
  content_type?: string | null
  contentType?: string | null
  object_key?: string
  objectKey?: string
}

export type DisplayArtifact = {
  id: string
  url: string
  alt: string
}

const IMAGE_EXTENSIONS = /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i
const RENDERED_IMAGE_KINDS = new Set([
  "image",
  "data_table",
  "table",
  "chart",
  "graph",
  "diagram",
  "figure",
])

const escapeAttr = (value: string): string =>
  value
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")

/** Generation often labels rendered PNGs as data_table/chart, not "image". */
export const isDisplayableImageArtifact = (artifact: ArtifactLike): boolean => {
  const contentType = (
    artifact.content_type ||
    artifact.contentType ||
    ""
  )
    .trim()
    .toLowerCase()
  if (contentType.startsWith("image/")) return true
  if (contentType) return false

  const path = (
    artifact.filename ||
    artifact.object_key ||
    artifact.objectKey ||
    ""
  ).toLowerCase()
  if (IMAGE_EXTENSIONS.test(path)) return true

  const kind = (
    artifact.artifact_type ||
    artifact.artifactType ||
    "image"
  ).toLowerCase()
  return RENDERED_IMAGE_KINDS.has(kind)
}

export const displayableArtifacts = (
  artifacts?: ArtifactLike[] | null
): DisplayArtifact[] => {
  if (!artifacts?.length) return []
  const seen = new Set<string>()
  const items: DisplayArtifact[] = []
  for (const artifact of artifacts) {
    const url = (artifact.download_url || artifact.downloadUrl || "").trim()
    if (!url) continue
    if (!isDisplayableImageArtifact(artifact)) continue
    const id =
      artifact.artifact_id ||
      artifact.artifactId ||
      artifact.object_key ||
      artifact.objectKey ||
      url
    if (seen.has(id)) continue
    seen.add(id)
    items.push({
      id,
      url,
      alt: artifact.filename || "Question figure",
    })
  }
  return items
}

export const htmlWithArtifacts = (
  html?: string | null,
  artifacts?: ArtifactLike[] | null
): string => {
  const body = (html || "").trim()
  const images = displayableArtifacts(artifacts)
    .map(
      (item) =>
        `<p><img src="${escapeAttr(item.url)}" alt="${escapeAttr(item.alt)}"></p>`
    )
    .join("")
  return `${body}${images}`
}
